<template>
  <div>
    <ol>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
      <li style="height:100px">Hello</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "SpacerList"
};
</script>